export const formatFileExtension = (fileName?: string) => {
  if (!fileName) {
    return '';
  }

  const extension = fileName.split('.').pop();
  return extension.length <= 4 ? extension.toUpperCase() : '';
};
